var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"center-block",staticStyle:{"display":"inline-block"},attrs:{"src":"/webroot/images/spinner.gif","height":"30","width":"30"}})
}
var staticRenderFns = []

export { render, staticRenderFns }